import * as Yup from 'yup';
import { DictMonetaryCurrency } from '@models';

export function useValidationSchema() {
  return Yup.object<DictMonetaryCurrency>().shape({
    name: Yup.string().nullable().required(),
    symbol: Yup.string().nullable().required(),
  });
}
